import { render, staticRenderFns } from "./PlvLiveRedirect.vue?vue&type=template&id=e671ce56&scoped=true&"
import script from "@/scripts/PlvLiveRedirect/index.js?vue&type=script&lang=js&"
export * from "@/scripts/PlvLiveRedirect/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671ce56",
  null
  
)

export default component.exports